'use client';

import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import type { ReactNode } from 'react';
import { formatCountFor } from '@/lib/format/format-count';
import { DURATION_POSITION_SMALL_MS } from '@/lib/ui/easing';
import { AnimatedNumber } from './animated-number';
import { Badge } from './app-badge';
export function AnimatedCountBadge(t0) {
  const $ = _c(10);
  const {
    value,
    hasMore: t1,
    animateOnMount: t2,
    "data-testid": testId
  } = t0;
  const hasMore = t1 === undefined ? false : t1;
  const animateOnMount = t2 === undefined ? true : t2;
  const locale = useLocale();
  let t3;
  if ($[0] !== locale) {
    t3 = formatCountFor(locale);
    $[0] = locale;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== animateOnMount || $[3] !== t3 || $[4] !== value) {
    t4 = <AnimatedNumber value={value} format={t3} duration={DURATION_POSITION_SMALL_MS} animateOnMount={animateOnMount} />;
    $[2] = animateOnMount;
    $[3] = t3;
    $[4] = value;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = hasMore ? "+" : null;
  let t6;
  if ($[6] !== t4 || $[7] !== t5 || $[8] !== testId) {
    t6 = <Badge variant="secondary" data-testid={testId}>{t4}{t5}</Badge>;
    $[6] = t4;
    $[7] = t5;
    $[8] = testId;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}